export const SIMPLIFIED_VIEW = Symbol('simplified booking view')
export const CALENDAR_VIEW = Symbol('calendar booking view')
export const WALKTHROUGH_SEEN_NOT_SET = Symbol('Walkthrough seen not set')
export const WALKTHROUGH_SEEN = Symbol('Walkthrough seen')
export const WALKTHROUGH_NOT_SEEN = Symbol('Walkthrough not seen')
export const PREFERENCES_VIEW_KEY = 'booking_default_view'
export const SHOW_WALKTHROUGH_TIMEOUT = 1000
export const BOOKING_MODIFICATION_KEY = 'didBookingMidificationWalkthrough'
export const SETTINGS_KEY = 'didSettingsWalkThrough'

export const viewToStringMap = {
  [SIMPLIFIED_VIEW]: 'simplified',
  [CALENDAR_VIEW]: 'calendar',
}

export const stringToViewMap = {
  simplified: SIMPLIFIED_VIEW,
  calendar: CALENDAR_VIEW,
}
